import React from 'react';
import { Button, Card, Flex, Text, Icon } from '@opendoor/bricks/core';

import { useSupportContacts } from 'sellDirect/helpers/useSupportContacts';
import { useContactUsModalContext } from 'sellDirect/helpers/ContactUsModalProvider';

interface ICannotRefreshCard {
  onClick?: () => void;
}

// component-test-check-ignore
/**
 * Cannot Refresh Card Without Context
 *
 *  @param {onClick} function - onClick event when clicking "contact us" link
 */
export const CannotRefreshCardWithoutContext: React.FC<ICannotRefreshCard> = ({ onClick }) => {
  return (
    <Card my={7} p={[7, 7, 7]} variant="primary" width="100%" data-testid="final-withdrawn-prompt">
      <Flex justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <Text
          lineHeight={['s1', null, 's2']}
          fontSize={['s1', null, 's2']}
          marginRight={[0, null, 8]}
          fontWeight="semibold"
          color="neutrals100"
        >
          Something went wrong. Contact your experience partner for help.
        </Text>
        {onClick && (
          <Button
            onClick={onClick}
            variant="link"
            justifyContent="flex-end"
            pr={0}
            size="sm"
            analyticsName="cake-withdrawn-prompt-contact-us-click"
            data-testid="withdrawn-prompt-contact-us-click"
            aria-label={null}
          >
            <Flex alignItems="center">
              <Text
                lineHeight={['s1', null, 's2']}
                fontSize={['s1', null, 's2']}
                color="brand50"
                mr={2}
                fontWeight="semibold"
              >
                Contact us
              </Text>
              <Icon name="chevron-right" color="brand50" size={16} aria-hidden />
            </Flex>
          </Button>
        )}
      </Flex>
    </Card>
  );
};

/**
 * Cannot Refresh Card
 */
export const CannotRefreshCard: React.FC = () => {
  const { openContactUsModal } = useContactUsModalContext();
  const { experiencePartner: experiencePartnerContact } = useSupportContacts();

  return (
    <CannotRefreshCardWithoutContext onClick={() => openContactUsModal(experiencePartnerContact)} />
  );
};
